module.exports = __webpack_public_path__ + "img/CN.87d6c351.svg";